import { defaultLinkStyle } from "components/ui/link";
import React from "react";

export type ContactValueIcon = React.ComponentType<React.SVGProps<SVGSVGElement>>;

export const contactValueLinkClasses = `min-w-0 truncate ${defaultLinkStyle}`;

export const contactValueTextClasses = "min-w-0 truncate text-gray-900";

export const stopClickPropagation = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    e.stopPropagation();
};

interface ContactValueRowProps {
    Icon: ContactValueIcon;
    children: React.ReactNode;
}

export const ContactValueRow: React.FC<ContactValueRowProps> = props => {
    const { Icon, children } = props;

    return (
        <div className="flex min-w-0 max-w-full items-center gap-1">
            <Icon className="h-4 w-4 flex-shrink-0 text-gray-500" aria-hidden="true" />
            {children}
        </div>
    );
};

interface ContactValueLabelProps {
    label: string | null;
}

export const ContactValueLabel: React.FC<ContactValueLabelProps> = props => {
    const { label } = props;

    if (!label) {
        return null;
    }

    return <span className="flex-shrink-0 text-xs text-gray-500">{label}</span>;
};
